module.exports = __webpack_public_path__ + "static/media/netflix.f84154cf.svg";